(function(){
    angular
        .module('appback')
        .directive('ngCoprologico051', coprologico051);

        coprologico051.$inject = ['ResultadosService','$timeout'];
        function coprologico051(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=coprologico051.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  sub: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	
		            	scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
			            });

			            if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { parasitos : [{}] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { parasitos : [{}] }};
				            }
				        }

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

	                    scope.optionsMicroorganismos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2parasitos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
		            	
	                	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	/*scope.optionsComentarios = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2comentariossubanalitica",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params,extra) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'comentariosub',
		                            //extra:scope.extraparams
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	scope.optionsPresencia = {
	                		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'presenciafrotis'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}*/

	                	scope.nuevoParasito = function(){
	                		scope.item.resultado.extra.resultado.parasitos.push({});
	                	}

	                	
	                    

		                //console.log(scope.optionsColor);
		            	/*scope.subanaliticas = [];
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,function(data){
			               scope.subanaliticas = data.subanaliticas;
			            });*/
			        });
		        }
          }
      }
})();